import styles from './ListBlock.module.scss';

export interface ListBlockProps {
  message?: string;
  list: string[] | React.ReactNode[];
  fontSize?: 'small' | 'medium' | 'large';
}

export const ListBlock = ({ message, list, fontSize = 'medium' }: ListBlockProps) => {
  if (!list) {
    return null;
  }
  return (
    <div className={`${styles[fontSize]} ${styles.container}`}>
      {message && <div>{message}</div>}
      <ul className={styles.listStyle}>
        {list.map((item, index) => (
          <li key={index} className={styles.listItem}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};
